import $ from 'jquery'
import {lockBody, unlockBody} from '../utils';

$('.js-open-site-search').on('click', function() {
  $('.js-home-site-search').fadeIn();
  $('.js-site-search-form').fadeIn();
  $('.site-header-handler').find('input').focus();
  $('body').addClass('search-active')
  lockBody()
})
